import { render, staticRenderFns } from "./viewStockDetails.vue?vue&type=template&id=d8b5e4f8&"
import script from "./viewStockDetails.vue?vue&type=script&lang=js&"
export * from "./viewStockDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports